module.exports = __webpack_public_path__ + "static/media/logo-mobile2.1b7af08d.svg";